import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  status: {
    height: 16,
  },
  title: {
    marginTop: 24,
    width: 162,
    height: 24,
  },
  planUsersCircle: {
    width: 29,
    height: 29,
    borderRadius: 14.5,
    marginRight: 17,
    marginTop: 8,
  },
  circle: {
    width: 29,
    height: 29,
    borderRadius: 14.5,
    marginLeft: 16,
    marginTop: 23,
  },
  planUsersSquare: {
    marginTop: 9,
    width: 120,
    height: 16,
  },
  planBodyFirstItemContainer: {
    marginTop: 13.5,
  },
  planBodyButtonContainer: {
    marginTop: 16,
    marginLeft: 50,
  },
  planBodyButton: {
    width: '100%',
    height: 40,
    borderRadius: 6,
  },
  planBodyItemContainer: {
    marginTop: 12,
  },
  planBodyItemCircle: {
    width: 33,
    height: 33,
    borderRadius: 6.2,
    marginRight: 17,
    marginTop: 8,
  },
  planBodyItemSquare: {
    marginTop: 7,
    width: '100%',
    height: 12,
  },
  planBodyItemTitleSquare: {
    width: '100%',
    height: 12.5,
  },
  planBodyItemSubTitleSquare: {
    marginTop: 16.6,
    width: '100%',
    height: 12.5,
  },
  planBodyItemButtonSquare: {
    marginTop: 27,
    marginBottom: 5,
    width: '100%',
    height: 28,
  },
  itemContainer: {
    marginTop: 16,
    marginBottom: 39,
  },
  marginStyle: {
    marginTop: 14.5,
    marginBottom: 15.5,
  },
  itemLeft: {
    height: 16,
  },
  itemRight: {
    height: 24,
  },
  priceVatValueContainer: {
    marginTop: 37,
  },
  priceVatValue: {
    height: 12,
  },
  button: {
    height: 16,
    width: 94,
    marginLeft: 115,
    marginTop: 15,
  },
  separator: (theme, marginTop = 22) => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
    marginTop: marginTop,
  }),
  separatorTwo: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
    marginTop: 18.5,
  }),
  separatorThree: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
    marginTop: 24,
  }),
});
